import React from "react";
import { InputArgument } from "./types";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Returns a validation error node for the given field + values, or null if valid.
 * Pure function — no side effects, safe to call during render.
 */
export function getFieldError(
  arg: InputArgument,
  values: string[]
): React.ReactNode | null {
  if (arg.Format === "json") {
    for (const v of values) {
      if (!v) continue;
      try {
        JSON.parse(v);
      } catch {
        return <span className="text-danger">Not valid JSON string</span>;
      }
    }
    return null;
  }

  if (arg.Format === "email") {
    if (values.some((v) => v && !EMAIL_RE.test(v))) {
      return <span className="text-danger">Not valid email address</span>;
    }
    return null;
  }

  return null;
}
